// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"a7a02decdcc86f3e7e18","873":"9bd1a18b1a1583530ddf"}[chunkId] + ".js";
};